import React, { useState, useEffect,useContext } from "react";
import { useDispatch, useSelector } from "react-redux";
import JsonView from "react18-json-view";
import "react18-json-view/src/style.css";
import { Grid } from "@mui/material";
import Table from "@mui/material/Table";
import TableCell from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";
import TableBody from "@mui/material/TableBody";
import Collapse from "@mui/material/Collapse";
import Button from "@mui/material/Button";
import { styled } from "@mui/material/styles";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import TablePagination from "@mui/material/TablePagination";
import Stack from "@mui/material/Stack";
import AddIcon from "@mui/icons-material/Add";
import {
     ContentRightWr,
     MainLeftTitle,
     CreateButton,
} from "../../../_uiComponents/WrapperComponents";
import { UiButton } from "../../../_uiComponents/common/form/UiButton";
import { dataTemplateDeleteJsonSchemaRequest, dataTemplateGetValueRequest, dataTemplateValueDeleteRequest, factTableGetValueRequest } from "../../../../_redux/_actions";
import UiSearch from "../../../_uiComponents/common/form/UiSearch";

import { contextApiActions, dataTemplateConstants } from "../../../../_redux/_constants";
import { Context } from "../../../../_context/Store";
import AddRecordDataModal  from "./AddRecordDataModal";
import UploadRecordSummary from "./UploadRecordSummary";
import EditRecordDataModal from "./EditRecodeDataModal";
import ParticipantUserInformation from "./ParticipantUserInformation";


export default function DataTemplatesManageData(props) {
     const [openList, setOpenList] = React.useState(false);
     const [page, setPage] = React.useState(1);
     const [rowsPerPage, setRowsPerPage] = React.useState(5);
     const [active, setActive] = React.useState();

     const actionDispatch = useDispatch();
     const [state, dispatch] = useContext(Context);

     const getManageDataList = (searchValue = "") => {
          actionDispatch(
               dataTemplateGetValueRequest({
                    id: props.id,
                    page: page,
                    pageSize: rowsPerPage,
                    search: searchValue,
               }),
          );
     };

     const { manageList, totalRecords, dataTableList } = useSelector((state) => {
          return {
               manageList: state.dataTemplate.manageDataValues.data,
               totalRecords: state.dataTemplate.manageDataValues.totalRecords,
               dataTableList: state.dataTemplate.list.data,
          };
     });
     


     useEffect(() => {
          getManageDataList();
     }, [page, rowsPerPage]);

     const dataUploadHandle = (clickedIndex) => {
          if (active === clickedIndex) {
               setActive(null);
               setOpenList(true);
          } else {
               setActive(clickedIndex);
               setOpenList(true);
          }
     };

     const handleChangePage = (event, newPage) => {
          setPage(newPage + 1);
     };


     const handleChangeRowsPerPage = (event) => {
          setRowsPerPage(event.target.value);
          setPage(1);
     };

     const handleAddRecord = () => {
          dispatch({
              type: contextApiActions.UI_MODAL_TOGGEL,
              payload: {
                  show: true,
                  heading: 'Add Record',
                  children: <AddRecordDataModal
                         Id={props.id}
                         getManageDataList={getManageDataList}
                   />,
              },
          });
      };

      const handleEditRecord = (id) => {
          dispatch({
              type: contextApiActions.UI_MODAL_TOGGEL,
              payload: {
                  show: true,
                  heading: 'Edit Record',
                  children: <EditRecordDataModal
                              id={id}
                              getManageDataList={getManageDataList}
                   />,
              },
          });
      };

      const deleteDataTemplateValue = (id) => {
          dispatch({
               type: contextApiActions.UI_CONFIRMATION_TOGGEL,
               payload: {
                    show: true,
                    okFunction: () =>
                         actionDispatch(
                              dataTemplateDeleteJsonSchemaRequest({
                                   id,
                                   dataTableId: props.id,
                                   page: page,
                                   pageSize: rowsPerPage,
                              }),
                         ),
               },
          });
     };

     const handleCreateParticipantUserAccounts = () =>{
          dispatch({
               type: contextApiActions.UI_EXTRA_LARGE_MODAL_TOGGEL,
               payload: {
                    show: true,
                    heading: 'Participant User Account Creation Summary',
                    children: <ParticipantUserInformation
                                   id={props.tableId}
                    />
               }
          })
     }

     const dataTemplateType = dataTableList.filter(datalist => datalist.id === props.tableId);
     
     return (
          <>
               <h2 className="sba-create-fact-table-heading">
                    {`Manage ${dataTemplateType[0]?.dataTemplateType} Template Data`}
               </h2>
               <div className="sba-fact-table-data-manage-top">
                    <div className="sba-fact-table-data-manage-top__left">
                         <div className="sba-add-record-button">
                              <Button
                                   variant="contained"
                                   startIcon={<AddIcon />}
                                   onClick={handleAddRecord}
                              >
                                   Add Record
                              </Button>
                         </div>
                         {dataTemplateType[0]?.dataTemplateType === dataTemplateConstants.PARTICIPANT &&
                              <div className="sba-add-record-button">
                                   <Button
                                        variant="contained"                              
                                        onClick={handleCreateParticipantUserAccounts}
                                   >
                                        Create Participant User Accounts
                                   </Button>
                              </div>
                         }                               
                    </div>
                    <div className="sba-fact-table-data-search">
                         <UiSearch onChange={getManageDataList} />
                    </div>
               </div>

               <Table sx={{ minWidth: 650, mt: 1 }}>
                    <TableBody>
                         {manageList.map((item, index) => (
                              <TableRow key={index}>
                                   <TableCell
                                        style={{
                                             paddingBottom: 0,
                                             paddingTop: 0,
                                             paddingLeft: 0,
                                             paddingRight: 0,
                                             background: "#f9f8f8",
                                             border: "none",
                                        }}
                                        colSpan={12}
                                   >
                                        <div
                                             className="sba-data-upload-summary-records"
                                             onClick={() => {
                                                  dataUploadHandle(index);
                                             }}
                                        >
                                             <span className="sba-data-upload-name">
                                                  {active == index &&
                                                  openList ? (
                                                       <KeyboardArrowUpIcon />
                                                  ) : (
                                                       <KeyboardArrowDownIcon />
                                                  )}
                                                  <h4>{`${item.identityColumn} : ${item.identityValue}`}</h4>
                                             </span>
                                             {/* <span className="sba-data-upload-status">
                                                  {item.status === "Fail" ? (
                                                       <span className="sba-dataupload-file-failed">
                                                            Failed
                                                       </span>
                                                  ) : (
                                                       <span className="sba-dataupload-file-success">
                                                            Success
                                                       </span>
                                                  )}
                                             </span> */}
                                        </div>
                                        <Collapse
                                             in={active == index && openList}
                                             timeout="auto"
                                             unmountOnExit
                                        >
                                             <Grid container spacing={2}>
                                                  <Grid item xs={12} lg={6}>
                                                       <div className="sba-upload-json-view">
                                                            <JsonView
                                                                 src={
                                                                      item.dataObject
                                                                 }
                                                                 editable={{
                                                                      delete: false,
                                                                      edit: true,
                                                                 }}
                                                                 onEdit={(
                                                                      params,
                                                                 ) => {
                                                                      console.log(
                                                                           params,
                                                                      );
                                                                 }}
                                                            />
                                                       </div>
                                                  </Grid>

                                                  {item?.errorList?.length >
                                                       0 && (
                                                       <Grid
                                                            item
                                                            xs={12}
                                                            lg={6}
                                                       >
                                                            <div className="sba-upload-error-list">
                                                                 <h5>
                                                                      Error List
                                                                 </h5>
                                                                 <ul>
                                                                      {item.errorList.map(
                                                                           (
                                                                                error,
                                                                           ) => (
                                                                                <li>
                                                                                     {
                                                                                          error
                                                                                     }
                                                                                </li>
                                                                           ),
                                                                      )}
                                                                 </ul>
                                                            </div>
                                                       </Grid>
                                                  )}
                                             </Grid>
                                             <Grid
                                                  container
                                                  sx={{
                                                       display: "flex",
                                                       textAlign: "right",
                                                       mt: 2,
                                                       mb: 2,
                                                  }}
                                             >
                                                  <Grid item xs={12} lg={12}>
                                                       <Stack
                                                            spacing={2}
                                                            direction="row"
                                                            justifyContent="end"
                                                            sx={{
                                                                 width: "100%",
                                                                 mt: 3,
                                                            }}
                                                       >
                                                            <UiButton
                                                                 name="Delete"
                                                                 variant="outlined"
                                                                 size="large"
                                                                 color="error"
                                                                 onClick={() =>
                                                                      deleteDataTemplateValue(
                                                                           item.id,
                                                                      )
                                                                 }
                                                            />
                                                            <UiButton
                                                                 name="Edit"
                                                                 variant="contained"
                                                                 size="large"
                                                                 onClick={() =>
                                                                      handleEditRecord(
                                                                           item.id,
                                                                      )
                                                                 }
                                                            />
                                                       </Stack>
                                                  </Grid>
                                             </Grid>
                                        </Collapse>
                                   </TableCell>
                              </TableRow>
                         ))}
                    </TableBody>
               </Table>
               <TablePagination
                    rowsPerPageOptions={[5, 10, 15, 20, 25]}
                    component="div"
                    count={totalRecords}
                    rowsPerPage={rowsPerPage}
                    page={page - 1}
                    onPageChange={handleChangePage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
               />
          </>
     );
}
